import script from "./TableHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./TableHeader.vue?vue&type=script&setup=true&lang=js"

import "./TableHeader.vue?vue&type=style&index=0&id=4756a2ea&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4756a2ea"]])

export default __exports__